define('controllers/admin/blog/editPostController',[
	"application",
		"jquery",
		"angular",
		"config",
		"underscore",
		"moment",
		"toastr",
		"postaljs",
		"application",
		"directives/bootstrap/ngBsDatepicker",
		"directives/jquery/ngJqUpload",
		"directives/jquery/sortable",
		"directives/common/redactor"
],
	function (app, $, angular, config, _, moment, toastr, postal) {
		"use strict";

		return app.controllers.controller("EditPost", ["$scope", "$window", function ($scope, $window) {

			$scope.isBusy = false;

			$scope.postId = null;

			$scope.post = {
				title: "",
				summary: "",
				url: "",
				created: null,
				published: false,
				content: ""
			};

			$scope.tags = [];

			$scope.addTag = function (scope, prevScope) {
				scope.tag.IsSelected = true;
			};

			$scope.removeTag = function (scope, prevScope) {
				scope.tag.IsSelected = false;
			};

			$scope.file = {
				uploading: false,
				url: config.admin.blog.picture,
				fileId: null,
				fileName: "File",
				progressValue: 0,
				clear: function () {
					$scope.file.uploading = false;
					$scope.file.fileId = null;
					$scope.file.fileName = "";
				},
				start: function () {
					$scope.$apply(function () {
						$scope.file.progressValue = 0;
						$scope.file.uploading = true;
					});
				},
				end: function () {
					$scope.$apply(function () {
						$scope.file.progressValue = 0;
						$scope.file.uploading = false;
					});
				},
				success: function (result) {
					$scope.file.fileId = result.FileId;
					$scope.file.fileName = result.FileName;
				},
				fail: function (xhr, err, status) {
					if (xhr.errorThrown == "MAX_SIZE_EXCEEDED")
						toastr.error("This file is more then 10 mb");
					else if ((xhr.jqXHR.status == 400) && (xhr.errorThrown == "INVALID_IMAGE"))
						toastr.error("This format is not supported.");
					else
						toastr.error("Unable to upload file. Please, try again later.");
				},
				progress: function (progress) {
					$scope.$apply(function () {
						$scope.file.progressValue = progress;
					});
				}
			};

			$scope.submit = function () {
				$scope.isBusy = true;

				$.post(config.admin.blog.post, {
					id: $scope.postId,
					title: $scope.post.title,
					summary: $scope.post.summary,
					url: $scope.post.url,
					created: $scope.post.created ? moment($scope.post.created).toISOString() : null,
					ispublished: $scope.post.published,
					content: $scope.post.content,
					description: $scope.post.description,
					tags: $.grep($scope.tags, function (x) { return x.IsSelected == true; }),
					pictureId: $scope.file.fileId
				})
					.always(function () {
						$scope.$apply(function () {
							$scope.isBusy = false;
						});
					})
					.fail(function (result) {
						toastr.error("Unable to create blog post.");
					})
					.done(function (result) {
						if (result && result.postId) {
							if ($scope.postId == 0 && result.postId) {
								return location.href = "/admin/blog/edit/" + result.postId;
							}

							$scope.$apply(function () {
								$scope.postId = result.postId;

								$scope.file.clear();
							});
						}
						toastr.success("Post saved.");
					});
			};

			var load = function () {
				$scope.isBusy = true;

				$.get(config.admin.blog.post + "/" + $scope.postId)
					.always(function () {
						$scope.$apply(function () {
							$scope.isBusy = false;
						});
					})
					.fail(function () {
						toastr.error("Unable to load blog post.");
					})
					.done(function (result) {
						if (result) {
							$scope.$apply(function () {
								console.log(result);
								$scope.post.title = result.Title;
								$scope.post.summary = result.Summary;
								$scope.post.url = result.Url;
								$scope.post.created = result.Created;
								$scope.post.published = result.IsPublished;
								$scope.post.content = result.Content;
								$scope.post.description = result.Description;

								$scope.tags = angular.copy(result.Tags);
							});
						}
					});
			};

			$scope.$watch("postId", load);

		}]);

	});
